import AppModal from "@/components/AppModal";
import AppTextField from "@/components/AppTextField";
import Backdrop from '@mui/material/Backdrop';
import {
  Box,
  Typography,
  Stack,
  styled,
  boxClasses,
  IconButton, TextField
} from '@mui/material'
import AppLoadingButton from "@/components/mui/LoadingButton";
import Fade from '@mui/material/Fade';
import API from "@/constant/API";
import {getCardList} from "@/redux/slices/card";
import {dispatch} from "@/redux/store";
import axiosInstance from "@/utils/axios";
import {isEmptyString} from "@/utils/utils";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {enqueueSnackbar} from "notistack";
import classes from "./index.module.css";
import styles from "@/components/BindEmailModal/BindEmailModal.module.css";
import RpIcon from "@/components/RpIcon.jsx";
const StyleTextField = styled(TextField)(({ theme }) => ({
  ".MuiInputBase-root":{
    "fieldset":{
      borderRadius:"6px"
    }
  }
}));
export default function CardLabelDialog({
                                          open,
                                          card,
                                          onClose,
                                          onConfirm
                                        }) {
  const {t} = useTranslation();
  const [label, setLabel] = useState(card?.label ?? '');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (card) {
      setLabel(card?.label ?? '');
    }
  }, [card]);

  const _onSave = async () => {
    if (loading || isEmptyString(label)) return;

    setLoading(true);
    try {
      const params = {
        cardId: card.cardId,
        label: label,
      }
      await axiosInstance.post(API.CARD_CHANGE_LABEL, params);
      setLabel('')
      // 修改标签后刷新卡列表
      dispatch(getCardList());
      enqueueSnackbar(t("card_tag_set_success"), {variant: 'success'})
      if (onConfirm) onConfirm();
      if (onClose) onClose();
    } finally {
      setLoading(false);
    }
  }

  const _onChange = (evt) => {
    setLabel(evt.target.value);
  }

  if (!card) return null;


  return (
    <AppModal open={open} onClose={onClose}
              title={t('card_tag')}
              closeAfterTransition
              slots={{backdrop: Backdrop}}
              slotProps={{
                backdrop: {
                  timeout: 500,
                },
              }}
    >
      <Stack direction="column" spacing={2} className={classes.modalContent}
      >
        <Stack className={styles.title} direction="row" justifyContent="space-between">
          <Box onClick={() => {onClose()}}><RpIcon icon="close" size={20}/></Box>
          <Typography>{t('card_tag')}</Typography>
        </Stack>
        <StyleTextField fullWidth placeholder={t('card_tag')} value={label}
                   onChange={_onChange}
                   autoComplete="off"
                  //  onClear={() => setLabel('')}
                  />
        <AppLoadingButton loading={loading} disabled={isEmptyString(label)} variant="contained"
                       onClick={_onSave} fullWidth>
          {t("confirm")}
        </AppLoadingButton>
      </Stack>
    </AppModal>
  );
}
